<div class="main-container">

    <div class="header-container">
        <div class="header-text-container">
            <div><p class="history-heading-map-data-field text-no-margin">Maps</p></div>
            <div><h2 class="splitter-map-data-field text-no-margin"> | </h2></div>
            <div><p class="farm-heading-map-data-field text-no-margin"> {{farmNameHeader}} </p></div>
        </div>

        <div class="close-icon-container">
            <div class="close-container"> <img src="../../../assets/icons/close.svg" alt="Icon description"
                 class="close-icon" (click)="onCloseClick()">
            </div>
        </div>

    </div>

    <mat-divider></mat-divider>

    <div class="secondary-container">

        <div class="side-nav-container">
            <div class="nav" [formGroup]="selectionState">

                <div class="nav-items">
                    <mat-list style="padding:0!important" *ngFor="let analysisType of analysisTypes | orderBy: 'name'">
                        <mat-list-item 
                            [disabled]="(!analysisType.available && !(analysisType?.type === 'GENERATED_VRT' && (viewVrt || viewVrtDownloader))) || (analysisType?.alias === 'PROFITABILITY' && !viewProfitability) || (analysisType?.type === 'GENERATED_VRT' && !viewVrt && !viewVrtDownloader)"
                            class="item" 
                            (click)="selectAnalysisType(analysisType)"
                            formControlName="prevSelect"
                            ngDefaultControl
                            [ngClass]="{'selected-item': analysisType.selected === true}">
                            <a #navAnalysisItem > {{analysisType.alias}}</a>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>

        <div class="period-item-list-container">

        <div class="coverage-carousel" *ngIf="isCoveragePercentageAnalysisType && !showVrtInputs">
            <div *ngFor="let coverageItem of mappedResponse" class="coverage-item-container"
                 [ngClass]="{
                'coverage-with-data': coverageItem.coveragePercentage === 100,
                'coverage-with-partial-data': coverageItem.coveragePercentage <= 99 && coverageItem.coveragePercentage >= 1,
                'coverage-no-data': coverageItem.coveragePercentage < 1
                }" 
                (click)="overlayCoverageCardMapsItem(coverageItem)">
            
            <div>
                <p class="text-no-margin coverage-date">{{coverageItem.imageDate}}</p>
                <div class="coverage-icon-container">
                    <div *ngIf="coverageItem.coveragePercentage === 100"><img class="map-img" src="{{coverageItem?.mapUrl?.length > 0 ? coverageItem.mapUrl : '../../../assets/icons/sunnyfullcoverage.svg'}}" alt="Icon description"></div>
                    <div *ngIf="coverageItem.coveragePercentage <= 99 && coverageItem.coveragePercentage >= 1"><img class="map-img" src="{{coverageItem?.mapUrl?.length > 0 ? coverageItem.mapUrl : '../../../assets/icons/cloudypartialcoverblue.svg'}}" alt="Icon description"></div>
                    <div *ngIf="coverageItem.coveragePercentage < 1" style="height: 55px;"><img class="map-img" src="{{coverageItem?.mapUrl?.length > 0 ? coverageItem.mapUrl : '../../../assets/icons/cloudcoverage.svg'}}" alt="Icon description"></div>
                </div>  

                <!-- <p class="text-no-margin coverage-detail-text">Date: <span class="coverage-detail-sub-text">{{coverageItem.date}}</span></p> -->
                <p class="text-no-margin coverage-detail-text">Coverage: <span class="coverage-detail-sub-text">{{coverageItem.coveragePercentage | number: '1.2-2'}}%</span></p>
            </div>

            </div>
        </div>




            <mat-button-toggle-group *ngIf="!disablePeriodRange" #periodGroup="matButtonToggleGroup"  class="toggle-group-container-field" [value]="selectedPeriod" (change)="clickPeriod(periodGroup.value)">
            <div class="period-btn-container">
                <div class="period-btn-container-field" >

                    <div *ngIf="helper.doesUserHaveRole('Analysis Reporting')" class="satellite-download-icon-field tooltip"  (click)="openSatelliteReportSelectionMenu()">
                        <img src="assets/icons/download.svg" alt="Download Icon" class="satellite-download-icon-field" data-tooltip="Generate">
                    </div>
                    
                    <mat-button-toggle   appAutoFocusDirective class="period-range-btn-field selected-button-field" type="button"
                             id="PeriodThirtyDays" (click)="clickPeriod('30 days')"
                             [disabled]="disablePeriodRange" [value]="'30 days'">30 Days </mat-button-toggle >

                    <mat-button-toggle  class="period-range-btn-field selected-button-field" type="button"
                            id="PeriodThreeMonths" (click)="clickPeriod('3 months')"
                            [disabled]="disablePeriodRange" [value]="'3 months'" >3 Months</mat-button-toggle >

                    <mat-button-toggle  class="period-range-btn-field selected-button-field"  type="button" id="PeriodSixMonths"
                            (click)="clickPeriod('6 months')"
                            [disabled]="disablePeriodRange" [value]="'6 months'" >6 Months</mat-button-toggle >

                    <mat-button-toggle  class="period-range-btn-field selected-button-field"  type="button" id="PeriodAll"
                            (click)="clickPeriod('all')"
                            [disabled]="disablePeriodRange" [value]="'all'" >All</mat-button-toggle >

                    <!-- Imagery Request Button -->
                    <div *ngIf="showImageryRequestButton" class="imagery-request-container">
                        <button mat-stroked-button class="flex items-center gap-1 h-9 px-3 text-[12px] border border-[var(--primary-dark)] text-[var(--primary-dark)] hover:bg-[var(--base-light-variant)] disabled:opacity-60 disabled:cursor-not-allowed" [matMenuTriggerFor]="imageryRequestMenu" [disabled]="isRequestingImagery">
                            <mat-icon>satellite_alt</mat-icon>
                            <span>Request</span>
                            <mat-icon>expand_more</mat-icon>
                        </button>
                        <mat-menu #imageryRequestMenu="matMenu" class="imagery-request-menu-compact" [hasBackdrop]="false">
                            <div class="bg-[var(--primary-dark)] text-white px-4 py-2.5 font-semibold text-[13px]" (click)="$event.stopPropagation()">Request NDVI Imagery</div>
                            
                            <div class="p-4 space-y-3 min-w-[280px]" (click)="$event.stopPropagation()">
                                <!-- Scope Dropdown -->
                                <div>
                                    <label class="block text-[11px] font-bold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Scope</label>
                                    <div class="relative" #scopeDropdown>
                                        <div (click)="showScopeMenu = !showScopeMenu; $event.stopPropagation()"
                                            class="w-full py-2 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)] transition-colors">
                                            <span>{{imageryRequestScope === 'FIELD' ? 'This Field Only' : 'Entire Farm (' + farmNameHeader + ')'}}</span>
                                            <span class="material-icons text-[18px] text-gray-400">expand_more</span>
                                        </div>
                                        <div *ngIf="showScopeMenu" class="absolute top-[calc(100%+4px)] left-0 right-0 bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.15)] py-1 z-[9999]">
                                            <div (click)="imageryRequestScope='FIELD'; showScopeMenu=false" 
                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                [class.font-semibold]="imageryRequestScope === 'FIELD'">This Field Only</div>
                                            <div (click)="imageryRequestScope='FARM'; showScopeMenu=false"
                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                [class.font-semibold]="imageryRequestScope === 'FARM'">Entire Farm ({{farmNameHeader}})</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Date Range Dropdown -->
                                <div>
                                    <label class="block text-[11px] font-bold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Date Range</label>
                                    <div class="relative" #dateDropdown>
                                        <div (click)="showDateMenu = !showDateMenu; $event.stopPropagation()"
                                            class="w-full py-2 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)] transition-colors">
                                            <span>{{getDateOptionLabel()}}</span>
                                            <span class="material-icons text-[18px] text-gray-400">expand_more</span>
                                        </div>
                                        <div *ngIf="showDateMenu" class="absolute top-[calc(100%+4px)] left-0 right-0 bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.15)] py-1 z-[9999]">
                                            <div (click)="imageryRequestDateOption='30days'; showDateMenu=false" 
                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                [class.font-semibold]="imageryRequestDateOption === '30days'">Last 30 Days</div>
                                            <div (click)="imageryRequestDateOption='60days'; showDateMenu=false"
                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                [class.font-semibold]="imageryRequestDateOption === '60days'">Last 60 Days</div>
                                            <div (click)="imageryRequestDateOption='90days'; showDateMenu=false"
                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                [class.font-semibold]="imageryRequestDateOption === '90days'">Last 90 Days</div>
                                            <div (click)="imageryRequestDateOption='custom'; showDateMenu=false"
                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                [class.font-semibold]="imageryRequestDateOption === 'custom'">Custom Range...</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Custom Date Pickers -->
                                <div *ngIf="imageryRequestDateOption === 'custom'" class="flex items-center gap-3" (click)="$event.stopPropagation()">
                                    <ui-datepicker label="FROM" [value]="imageryRequestDateFromStr" (valueChange)="onDateFromChange($event)" [compact]="true"></ui-datepicker>
                                    <ui-datepicker label="TO" [value]="imageryRequestDateToStr" (valueChange)="onDateToChange($event)" [compact]="true"></ui-datepicker>
                                </div>

                                <button (click)="submitImageryRequest()" [disabled]="isRequestingImagery"
                                    class="w-full bg-[var(--primary-dark)] hover:opacity-90 disabled:opacity-50 text-white font-semibold text-[13px] py-2.5 px-4 rounded-lg flex items-center justify-center gap-2 transition-opacity">
                                    <span class="material-icons text-[18px]" *ngIf="!isRequestingImagery">send</span>
                                    <mat-spinner *ngIf="isRequestingImagery" diameter="16"></mat-spinner>
                                    <span>{{isRequestingImagery ? 'Requesting...' : 'Request'}}</span>
                                </button>
                            </div>
                        </mat-menu>
                    </div>
                </div>

            </div>
            </mat-button-toggle-group>
            <div class="map-data-list-container-field" [style.align-items]="(showProfitabilityInputs || showVrtInputs) ? 'flex-start' : 'stretch'" [style.height]="(showProfitabilityInputs || showVrtInputs) ? '100%' : '64%'">
        <!--Profitability Inputs-->
        <div *ngIf="showProfitabilityInputs">
            <div style="padding: 20px;">
                <h3 style="margin-bottom: 20px;">Profitability Map Generator</h3>
                
                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;">
                    <mat-label>Select Year</mat-label>
                    <mat-select [(ngModel)]="selectedYieldYear" (selectionChange)="onYieldYearChange()">
                        <mat-option *ngFor="let year of availableYieldYears" [value]="year">
                            {{year}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;">
                    <mat-label>Select Yield Map</mat-label>
                    <mat-select [(ngModel)]="selectedYieldMap" [disabled]="!selectedYieldYear">
                        <mat-option *ngFor="let yieldMap of filteredYieldMaps" [value]="yieldMap">
                            {{yieldMap.items[0]?.propertyTypeName || formatDate(yieldMap.datePerformed, 'YYYY-MM-DD')}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;">
                    <mat-label>Input Cost (R/ha)</mat-label>
                    <input matInput type="number" [(ngModel)]="inputCost" placeholder="e.g. 5000">
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;">
                    <mat-label>Product Price (R/ton)</mat-label>
                    <input matInput type="number" [(ngModel)]="productPrice" placeholder="e.g. 3500">
                </mat-form-field>

                <button mat-flat-button style="width: 100%;" (click)="generateProfitabilityMap()">
                    Generate Profitability Map
                </button>

                <mat-divider style="margin: 30px 0 20px 0;"></mat-divider>

                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
                    <h4 style="margin: 0;">Previously Created Profitability Maps</h4>
                    <button mat-icon-button (click)="loadProfitabilityMaps()" [disabled]="isLoadingProfitabilityMaps" matTooltip="Refresh list">
                        <mat-spinner *ngIf="isLoadingProfitabilityMaps" diameter="20"></mat-spinner>
                        <mat-icon *ngIf="!isLoadingProfitabilityMaps">refresh</mat-icon>
                    </button>
                </div>
                
                <div *ngIf="isLoadingProfitabilityMaps" style="text-align: center; padding: 20px;">
                    <mat-spinner diameter="40" style="margin: 0 auto;"></mat-spinner>
                </div>
                
                <div *ngIf="!isLoadingProfitabilityMaps && availableProfitabilityMaps.length === 0" style="text-align: center; padding: 20px; color: #666;">
                    <p>No profitability maps available</p>
                </div>

                <div style="max-height: 300px; overflow-y: auto;">
                    <ng-container *ngIf="!isLoadingProfitabilityMaps">
                        <ng-container *ngFor="let profitMap of availableProfitabilityMaps">
                            <div class="list-item-analysis-container-field" 
                                 *ngIf="profitMap.items?.[0]?.mapUrl"
                                 (click)="overlayAnalysis(profitMap.analysisId, profitMap.datePerformed, profitMap.type, profitMap.items[0])">
                                <div class="list-item-analysis-field">
                                    <div><p class="list-item-field">{{formatTimestampUTC(profitMap.lastModified)}} (ID: {{profitMap.analysisId}})</p></div>
                                    <div><h4 class="list-item-spacer-field">  </h4></div>
                                    <div><p class="list-item-original-field"></p></div>
                                    <div class="view-eye-icon-container-field"><img src="../../../assets/icons/view-eye.svg"
                                                                                    alt="Icon description" class="view-eye-icon-field"></div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>

        <!--List Item for non Chemical items-->
        <div *ngIf="showAnalysisList">
            <div class="list-item-analysis-container-field" *ngFor="let analysisTypeListItem of filteredList"
                 (click)="overlayAnalysis(analysisTypeListItem.analysisId, analysisTypeListItem.datePerformed,analysisTypeListItem.type,analysisTypeListItem.items[0])">
                <div class="list-item-analysis-field">
                    <div><p class="list-item-field">
                        {{
                             analysisTypeListItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase()) ?
                             (formatDate(analysisTypeListItem.datePerformed, 'YYYY'))
                             : analysisTypeListItem.datePerformed
                        }}
                    </p></div>
                    <div><h4 class="list-item-spacer-field">  </h4></div>
                    <div><p class="list-item-original-field"></p></div>
                    <div class="view-eye-icon-container-field"><img src="../../../assets/icons/view-eye.svg"
                                                                    alt="Icon description" class="view-eye-icon-field"></div>
                </div>
            </div>
            <div class="load-more-btn-container" 
                *ngIf="this.filteredItemObj.type.toLowerCase().includes('SATELLITE'.toLowerCase()) && !this.filteredItemObj.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase()) && this.filteredItemObj.period != 'all' && showNoDataCard">
                <div class="Load-More-btn-container-field" >
                    <button  class="Load-More-btn-field" mat-flat-button type="button" (click)="loadMore()">Load More</button>
                </div>
            </div>
        </div>


        <div *ngIf="showChemList">
            <mat-expansion-panel class="chem-list-main-container" *ngFor="let analysisTypeListItem of filteredList">
                <mat-expansion-panel-header>
                    <mat-panel-title class="maps-chem-item-main-header-field">
                        <div *ngIf="!analysisTypeListItem.type.toLowerCase().includes('satellite') && analysisTypeListItem.type.toLowerCase().includes('chemical') && helper.doesUserHaveRole('Analysis Reporting')" class="download-icon-field tooltip"  (click)="generateFieldAnalysisReport(formatDate(analysisTypeListItem.datePerformed, 'YYYY'), $event)">
                            <img  src="assets/icons/download.svg" alt="Download Icon" class="download-icon-field" data-tooltip="Generate">
                            <!-- <span class="tooltiptext">Generate Report</span> -->
                        </div>
                        {{formatDate(analysisTypeListItem.datePerformed, 'YYYY')}}
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="maps-chem-item-header">
                    <label class=""></label>
                    <div class="">
                        <div class="maps-chem-item-container-field" *ngFor="let item of analysisTypeListItem.items">
                            <label class=""></label><br/>
                            <label class="item-chem-field"
                                   (click)="overlayAnalysis(analysisTypeListItem.analysisId,analysisTypeListItem.datePerformed, analysisTypeListItem.type, item)">{{item.propertyTypeName}}</label>
                            <div class="chem-view-eye-icon-field"><img src="assets/icons/view-eye.svg" alt="Icon description"
                                                                       class="chem-view-eye-icon-field"></div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>

        </div>

        <!-- VRT Inputs -->
        <div *ngIf="showVrtInputs" style="width: 100%;">
            <div style="padding: 0 20px;">
                <h3 style="margin: 20px 0;">Generated VRT</h3>

                <!-- Creator UI -->
                <div *ngIf="viewVrt">

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;">
                    <mat-label>Select Base Map Type</mat-label>
                    <mat-select [(ngModel)]="selectedVrtBaseType" (selectionChange)="onVrtBaseTypeSelected()">
                        <mat-option *ngFor="let map of vrtBaseMapOptions" [value]="map">{{ map.alias }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;" *ngIf="availableVrtYears.length > 0">
                    <mat-label>Select Year</mat-label>
                    <mat-select [(ngModel)]="selectedVrtYear" (selectionChange)="onVrtYearChange()">
                        <mat-option *ngFor="let year of availableVrtYears" [value]="year">{{ year }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <div *ngIf="selectedVrtYear && filteredVrtMaps.length === 0" style="text-align: center; padding: 10px;">
                    <mat-spinner diameter="24" style="margin: 0 auto;"></mat-spinner>
                </div>

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;" *ngIf="filteredVrtMaps.length > 0">
                    <mat-label>Select Map</mat-label>
                    <mat-select [(ngModel)]="selectedVrtBaseMap" (selectionChange)="onVrtBaseMapSelected()">
                        <mat-option *ngFor="let map of filteredVrtMaps" [value]="map">
                            {{ formatDate(map.datePerformed, 'YYYY-MM-DD') }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div *ngIf="selectedVrtBaseMap && vrtPropertyTypes.length === 0 && !selectedVrtPropertyType" style="text-align: center; padding: 10px;">
                    <mat-spinner diameter="24" style="margin: 0 auto;"></mat-spinner>
                </div>

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;" *ngIf="vrtPropertyTypes.length > 1">
                    <mat-label>Select Property</mat-label>
                    <mat-select [(ngModel)]="selectedVrtPropertyType" (selectionChange)="onVrtPropertyTypeSelected()">
                        <mat-option *ngFor="let pt of vrtPropertyTypes" [value]="pt">{{ pt.name }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;">
                    <mat-label>Map Name</mat-label>
                    <input matInput [(ngModel)]="vrtMapName" placeholder="e.g. Nitrogen Application Spring 2025">
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;">
                    <mat-label>Product</mat-label>
                    <input matInput [(ngModel)]="vrtProduct" placeholder="e.g. Urea">
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 15px;">
                    <mat-label>Unit</mat-label>
                    <mat-select [(ngModel)]="vrtUnit">
                        <mat-option *ngFor="let u of vrtUnits" [value]="u.value">{{ u.label }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <div *ngIf="vrtLegendBands.length > 0" style="margin-bottom: 20px;">
                    <h4 style="margin-bottom: 10px;">Rate Assignments</h4>
                    <div style="display: flex; gap: 48px;">
                        <img *ngIf="getVrtSourceMapUrl()" [src]="getVrtSourceMapUrl()" alt="Source analysis" style="width: 350px; height: auto; border-radius: 4px; object-fit: contain; flex-shrink: 0;">
                        <div style="flex: 1;">
                            <div *ngFor="let band of vrtLegendBands" style="display: flex; align-items: center; margin-bottom: 8px; gap: 10px;">
                                <div [style.background-color]="band.colour" style="width: 20px; height: 20px; border-radius: 3px; flex-shrink: 0;"></div>
                                <span style="flex: 1; font-size: 13px;">{{ band.label }}</span>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                    <input matInput type="number" [(ngModel)]="band.assignedRate" placeholder="Rate">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>

                <button mat-flat-button style="width: 100%;" [disabled]="!canGenerateVrt() || isGeneratingVrt" (click)="generateVrt()">
                    <span *ngIf="!isGeneratingVrt">{{ vrtCurrentAnalysisId ? 'Regenerate VRT Map' : 'Generate VRT Map' }}</span>
                    <span *ngIf="isGeneratingVrt">Generating...</span>
                </button>

                <button mat-flat-button color="primary" style="width: 100%; margin-top: 10px;" 
                        *ngIf="vrtCurrentAnalysisId && !vrtIsFinalised"
                        [disabled]="isGeneratingVrt"
                        (click)="openFinaliseDialog()">
                    {{ isGeneratingVrt ? 'Finalising...' : 'Finalise VRT Map' }}
                </button>

                <button mat-stroked-button style="width: 100%; margin-top: 10px;" 
                        *ngIf="vrtCurrentAnalysisId"
                        (click)="cancelEditVrt()">
                    Cancel
                </button>
                </div>

                <mat-divider style="margin: 30px -20px 20px -20px; width: calc(100% + 40px);"></mat-divider>

                <h4 style="margin-bottom: 15px;">Existing VRT Maps</h4>
                <div *ngIf="displayedVrtMaps.length === 0" style="display: flex; justify-content: center; align-items: center; padding: 40px 0; color: #666; width: 100%;">
                    <p style="margin: 0;">No generated VRT maps available</p>
                </div>
                <div *ngFor="let vrt of displayedVrtMaps" 
                     style="padding: 10px; border: 1px solid #eee; border-radius: 4px; margin-bottom: 8px;"
                     [style.border-color]="vrtCurrentAnalysisId === vrt.analysisId ? 'var(--primary-dark)' : '#eee'">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div>
                            <span style="font-weight: 500;">{{ vrt.mapName }}</span>
                            <span style="font-size: 12px; color: #666; margin-left: 8px;">{{ vrt.isFinalised ? '' : '(Draft)' }}</span>
                        </div>
                        <div style="display: flex; gap: 4px;">
                            <button mat-icon-button matTooltip="Overlay on map" (click)="selectExistingVrt(vrt)">
                                <mat-icon style="font-size: 18px;">layers</mat-icon>
                            </button>
                            <button mat-icon-button matTooltip="Edit" *ngIf="viewVrt && !vrt.isFinalised" (click)="editVrt(vrt)">
                                <mat-icon style="font-size: 18px;">edit</mat-icon>
                            </button>
                            <button mat-icon-button matTooltip="Create new version" *ngIf="viewVrt && vrt.isFinalised" (click)="newVersionVrt(vrt)">
                                <mat-icon style="font-size: 18px;">content_copy</mat-icon>
                            </button>
                            <button mat-icon-button matTooltip="Download shapefile" *ngIf="vrt.isFinalised" (click)="downloadVrt(vrt)">
                                <mat-icon style="font-size: 18px;">download</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!showNoDataCard && !showProfitabilityInputs && !showVrtInputs" class="no-data-container-field">
            <h3>SORRY</h3>
            <p>NO DATA AVAILABLE</p>
            <p>Please select another analysis type,</p>
            <p>period range, or use the load more button below.</p>
        </div>
            </div>
        </div>
    </div>
